import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { AppComponent } from './app.component';
import { EventListViewComponent } from './components/event-list-view/event-list-view.component';

// Providers

import { EventItemComponent } from './components/event-item/event-item.component';
import { EventListFilterComponent } from './components/event-list-filter/event-list-filter.component';
import { EventListWidgetComponent } from './components/event-list-widget/event-list-widget.component';
import { ServiceWorkerModule } from '@angular/service-worker';
import { EventsResultsFiltersService } from './services/events-results-filters.service';
import { CoreModule, ServicesModule, CacheInterceptorService } from 'world-archery-lib';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { EventsRouterResultsModule } from './app.routing.module';
import { LiveEventsPanelComponent } from './components/live-events-panel/live-events-panel.component';
import { CommonModule } from '@angular/common';
import { CommonPageComponentsModule } from '../common-page-components/common-page-components.module';

@NgModule({
  declarations: [
    AppComponent,
    EventListViewComponent,
    EventItemComponent,
    EventListFilterComponent,
    EventListWidgetComponent,
    LiveEventsPanelComponent
  ],
  imports: [
    CommonModule,
    HttpClientModule,
    FormsModule,
    EventsRouterResultsModule,
    CoreModule,
    SlickCarouselModule,
    CommonPageComponentsModule,
    CoreModule,
    ServicesModule
    //ServiceWorkerModule.register('/sites/all/modules/custom/wa_angular/includes/plugins/content_types/main/ngsw-worker.js', { enabled: environment.production })
  ],
  providers: [
    EventsResultsFiltersService,
    { provide: HTTP_INTERCEPTORS, useClass: CacheInterceptorService, multi: true }

  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
